import { render, staticRenderFns } from "./forgetpwd.vue?vue&type=template&id=b6095b94&scoped=true&"
import script from "./forgetpwd.vue?vue&type=script&lang=js&"
export * from "./forgetpwd.vue?vue&type=script&lang=js&"
import style0 from "./forgetpwd.vue?vue&type=style&index=0&id=b6095b94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6095b94",
  null
  
)

export default component.exports